import { XMLElementParser } from './XMLElementParser';
export class Note extends XMLElementParser {
    get unpitched() {
        const node = this.node.elements?.find(e => e.name === 'unpitched');
        if (node == null) {
            return undefined;
        }
        const step = node.elements?.find(e => e.name === 'display-step')?.elements?.[0]?.text;
        const octave = node.elements?.find(e => e.name === 'display-octave')?.elements?.[0]?.text;
        return { step, octave };
    }
    get pitch() {
        const node = this.node.elements?.find(e => e.name === 'pitch');
        if (node == null) {
            return undefined;
        }
        const step = node.elements?.find(e => e.name === 'step')?.elements?.[0]?.text;
        const octave = node.elements?.find(e => e.name === 'octave')?.elements?.[0]?.text;
        return { step, octave };
    }
    get duration() {
        const duration = this.node.elements?.find(e => e.name === 'duration')?.elements?.[0]?.text;
        if (duration == null) {
            throw new Error('duration is undefined');
        }
        return duration;
    }
    get isRest() {
        return this.node.elements?.some(e => e.name === 'rest') ?? false;
    }
    get isMeasureRest() {
        return this.node.elements?.find(e => e.name === 'rest')?.attributes?.measure == 'yes' ?? false;
    }
    get instrumentId() {
        const instrumentId = this.node.elements?.find(e => e.name === 'instrument')?.attributes?.id;
        return instrumentId;
    }
    get voice() {
        return this.node.elements?.find(e => e.name === 'voice')?.elements?.[0]?.text;
    }
    get noteType() {
        return this.node.elements?.find(e => e.name === 'type')?.elements?.[0]?.text;
    }
    get value() {
        if (this.noteType != null && this.noteType in noteValues) {
            return noteValues[this.noteType];
        }
        return undefined;
    }
    get isChord() {
        return this.node.elements?.find(e => e.name === 'chord') != null;
    }
    get timeModification() {
        const timeModification = this.node.elements?.find(e => e.name === 'time-modification');
        if (timeModification == null) {
            return null;
        }
        const actualNotes = timeModification.elements?.find(e => e.name === 'actual-notes')?.elements?.[0]?.text;
        const normalNotes = timeModification.elements?.find(e => e.name === 'normal-notes')?.elements?.[0]?.text;
        return {
            actualNotes, normalNotes
        };
    }
    get isAccentuated() {
        return this.notations?.articulations?.isAccentuated ?? false;
    }
    get dots() {
        return this.node.elements?.filter(e => e.name === 'dot')?.length ?? 0;
    }
    get notations() {
        const notationsNode = this.node.elements?.find(e => e.name === 'notations');
        if (notationsNode == null) {
            return undefined;
        }
        return new Notations(notationsNode);
    }
}
const noteValues = {
    '1024th': [1, 1024], '512th': [1, 512], '256th': [1, 256], '128th': [1, 128],
    '64th': [1, 64], '32nd': [1, 32], '16th': [1, 16],
    'eighth': [1, 8], 'quarter': [1, 4], 'half': [1, 2],
    'whole': [1, 1], 'breve': [2, 1], 'long': [4, 1], 'maxima': [8, 1]
};
export class Notations extends XMLElementParser {
    get articulations() {
        const articulationsNode = this.node.elements?.find(e => e.name === 'articulations');
        return articulationsNode
            ? new Articulations(articulationsNode)
            : undefined;
    }
}
export class Articulations extends XMLElementParser {
    get isAccentuated() {
        return this.node.elements?.some(e => e.name === 'accent') ?? false;
    }
}
//# sourceMappingURL=Note.js.map